import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
export var scale = {
  one: 1,
  thousand: 1000,
  million: 1000000,
  milliard: 1000000000
};
export var units = {
  one: '',
  thousand: 'm',
  million: 'M',
  milliard: 'MM'
};
export var getNumberFromDisplayDecimal = function getNumberFromDisplayDecimal(num) {
  return Number(num.replace(/\./g, ''));
};